export default __webpack_public_path__ + "static/doodle-header-9fed836cc3dfe996c92d6abd4489d506.svg";